export const formatBytes = (bytes: number, decimals = 2): string => {
  const sizes = ['bytes', 'kb', 'MB', 'GB', 'TB', 'PB'];
  if (bytes === 0) return `0 ${sizes[0]}`;

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};
